import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@src/store';

const UpsertMissionReducer = (state: RootState) => state.UpsertMissionReducer;
const UpsertMissionState = createSelector([UpsertMissionReducer], (state) => state);

export const selectWaypoints = createSelector([UpsertMissionState], (state) => state.waypoints);
export const selectDrone = createSelector([UpsertMissionState], (state) => state.selectedDrone);
export const selectSidebarType = createSelector([UpsertMissionState], (state) => state.sidebarType);
export const selectHoveredDrone = createSelector([UpsertMissionState], (state) => state.hoveredDrone);
export const selectEditableRoute = createSelector([UpsertMissionState], (state) => state.editableRoute);
export const selectTerrainMode = createSelector([UpsertMissionState], (state) => state.terrainMode);